// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-text,
.skeleton-card,
.skeleton-list,
.skeleton-table,
.skeleton-chart,
.skeleton-form,
.skeleton-custom {
  width: 100%;
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-bottom: 8px;
  display: block;
}

.skeleton-pulse .skeleton-line {
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

.skeleton-wave .skeleton-line {
  animation: skeleton-wave 1.5s ease-in-out infinite;
}

@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
@keyframes skeleton-wave {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
.skeleton-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.skeleton-card .skeleton-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
}
.skeleton-card .skeleton-card-header .skeleton-avatar {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  flex-shrink: 0;
}
.skeleton-card .skeleton-card-header .skeleton-card-title {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.skeleton-card .skeleton-card-content {
  margin-bottom: 16px;
}
.skeleton-card .skeleton-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.skeleton-list .skeleton-list-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;
}
.skeleton-list .skeleton-list-item:last-child {
  border-bottom: none;
}
.skeleton-list .skeleton-list-item .skeleton-avatar {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  flex-shrink: 0;
}
.skeleton-list .skeleton-list-item .skeleton-list-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-table .skeleton-table-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  padding: 12px 0;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 8px;
}
.skeleton-table .skeleton-table-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}
.skeleton-table .skeleton-table-row:last-child {
  border-bottom: none;
}

.skeleton-chart .skeleton-chart-header {
  margin-bottom: 20px;
}
.skeleton-chart .skeleton-chart-content {
  height: 200px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 20px;
}
.skeleton-chart .skeleton-chart-content .skeleton-chart-bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 8px;
}
.skeleton-chart .skeleton-chart-content .skeleton-chart-bars .skeleton-chart-bar {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  width: 100%;
  border-radius: 4px 4px 0 0;
  min-height: 20px;
}
.skeleton-chart .skeleton-chart-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.skeleton-form .skeleton-form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.skeleton-form .skeleton-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
}

@media (max-width: 768px) {
  .skeleton-card {
    padding: 12px;
    margin-bottom: 16px;
  }
  .skeleton-card .skeleton-card-header {
    margin-bottom: 12px;
    gap: 8px;
  }
  .skeleton-card .skeleton-card-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .skeleton-list .skeleton-list-item {
    padding: 8px 0;
    gap: 8px;
  }
  .skeleton-table .skeleton-table-header,
  .skeleton-table .skeleton-table-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .skeleton-chart .skeleton-chart-content {
    height: 150px;
    padding: 0 10px;
  }
  .skeleton-chart .skeleton-chart-content .skeleton-chart-bars {
    gap: 4px;
  }
  .skeleton-form .skeleton-form-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
}
:host-context(body.theme-dark) .skeleton-line,
:host-context(body.theme-dark) .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-chart-bar {
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}
:host-context(body.theme-dark) .skeleton-card {
  background: #1a1a1a;
  border-color: #3a3a3a;
}
:host-context(body.theme-dark) .skeleton-list .skeleton-list-item {
  border-bottom-color: #3a3a3a;
}
:host-context(body.theme-dark) .skeleton-table .skeleton-table-header {
  border-bottom-color: #3a3a3a;
}
:host-context(body.theme-dark) .skeleton-table .skeleton-table-row {
  border-bottom-color: #3a3a3a;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-loader/skeleton-loader.component.scss"],"names":[],"mappings":"AACA;;;;;;;EAOE,WAAA;AAAF;;AAGA;EACE,yEAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAIA;EACE,mDAAA;AADF;;AAIA;EACE,kDAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;EAGA;IACE,YAAA;EADF;EAGA;IACE,UAAA;EADF;AACF;AAIA;EACE;IACE,4BAAA;EAFF;EAIA;IACE,2BAAA;EAFF;AACF;AAMA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,wCAAA;AAJF;AAME;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAJJ;AAMI;EACE,yEAAA;EACA,0BAAA;EACA,cAAA;AAJN;AAOI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AALN;AASE;EACE,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AARJ;;AAcE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,SAAA;AAXJ;AAaI;EACE,mBAAA;AAXN;AAcI;EACE,yEAAA;EACA,0BAAA;EACA,cAAA;AAZN;AAeI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAbN;;AAoBE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;;AAyBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AAvBJ;AAyBI;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAvBN;AAyBM;EACE,yEAAA;EACA,0BAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;AAvBR;AA4BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA1BJ;;AAgCE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA9BJ;;AAmCA;EACE;IACE,aAAA;IACA,mBAAA;EAhCF;EAkCE;IACE,mBAAA;IACA,QAAA;EAhCJ;EAmCE;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAjCJ;EAsCE;IACE,cAAA;IACA,QAAA;EApCJ;EAyCE;;IAEE,0BAAA;IACA,QAAA;EAvCJ;EA4CE;IACE,aAAA;IACA,eAAA;EA1CJ;EA4CI;IACE,QAAA;EA1CN;EAgDE;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EA9CJ;AACF;AAoDE;;;EAGE,yEAAA;EACA,0BAAA;AAlDJ;AAqDE;EACE,mBAAA;EACA,qBAAA;AAnDJ;AAuDI;EACE,4BAAA;AArDN;AA0DI;EACE,4BAAA;AAxDN;AA2DI;EACE,4BAAA;AAzDN","sourcesContent":["// Skeleton Loader Base Styles\n.skeleton-text,\n.skeleton-card,\n.skeleton-list,\n.skeleton-table,\n.skeleton-chart,\n.skeleton-form,\n.skeleton-custom {\n  width: 100%;\n}\n\n.skeleton-line {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n// Animation Styles\n.skeleton-pulse .skeleton-line {\n  animation: skeleton-pulse 1.5s ease-in-out infinite;\n}\n\n.skeleton-wave .skeleton-line {\n  animation: skeleton-wave 1.5s ease-in-out infinite;\n}\n\n@keyframes skeleton-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes skeleton-wave {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n// Card Skeleton\n.skeleton-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  background: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .skeleton-card-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n    gap: 12px;\n\n    .skeleton-avatar {\n      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n      background-size: 200% 100%;\n      flex-shrink: 0;\n    }\n\n    .skeleton-card-title {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n    }\n  }\n\n  .skeleton-card-content {\n    margin-bottom: 16px;\n  }\n\n  .skeleton-card-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n  }\n}\n\n// List Skeleton\n.skeleton-list {\n  .skeleton-list-item {\n    display: flex;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n    gap: 12px;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .skeleton-avatar {\n      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n      background-size: 200% 100%;\n      flex-shrink: 0;\n    }\n\n    .skeleton-list-content {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n    }\n  }\n}\n\n// Table Skeleton\n.skeleton-table {\n  .skeleton-table-header {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 16px;\n    padding: 12px 0;\n    border-bottom: 2px solid #e0e0e0;\n    margin-bottom: 8px;\n  }\n\n  .skeleton-table-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 16px;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n}\n\n// Chart Skeleton\n.skeleton-chart {\n  .skeleton-chart-header {\n    margin-bottom: 20px;\n  }\n\n  .skeleton-chart-content {\n    height: 200px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    padding: 0 20px;\n    margin-bottom: 20px;\n\n    .skeleton-chart-bars {\n      display: flex;\n      align-items: flex-end;\n      justify-content: space-between;\n      width: 100%;\n      height: 100%;\n      gap: 8px;\n\n      .skeleton-chart-bar {\n        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n        background-size: 200% 100%;\n        width: 100%;\n        border-radius: 4px 4px 0 0;\n        min-height: 20px;\n      }\n    }\n  }\n\n  .skeleton-chart-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n// Form Skeleton\n.skeleton-form {\n  .skeleton-form-group {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .skeleton-form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    margin-top: 24px;\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .skeleton-card {\n    padding: 12px;\n    margin-bottom: 16px;\n\n    .skeleton-card-header {\n      margin-bottom: 12px;\n      gap: 8px;\n    }\n\n    .skeleton-card-footer {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n  }\n\n  .skeleton-list {\n    .skeleton-list-item {\n      padding: 8px 0;\n      gap: 8px;\n    }\n  }\n\n  .skeleton-table {\n    .skeleton-table-header,\n    .skeleton-table-row {\n      grid-template-columns: 1fr;\n      gap: 8px;\n    }\n  }\n\n  .skeleton-chart {\n    .skeleton-chart-content {\n      height: 150px;\n      padding: 0 10px;\n\n      .skeleton-chart-bars {\n        gap: 4px;\n      }\n    }\n  }\n\n  .skeleton-form {\n    .skeleton-form-actions {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 8px;\n    }\n  }\n}\n\n// Dark mode support\n:host-context(body.theme-dark) {\n  .skeleton-line,\n  .skeleton-avatar,\n  .skeleton-chart-bar {\n    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);\n    background-size: 200% 100%;\n  }\n\n  .skeleton-card {\n    background: #1a1a1a;\n    border-color: #3a3a3a;\n  }\n\n  .skeleton-list {\n    .skeleton-list-item {\n      border-bottom-color: #3a3a3a;\n    }\n  }\n\n  .skeleton-table {\n    .skeleton-table-header {\n      border-bottom-color: #3a3a3a;\n    }\n\n    .skeleton-table-row {\n      border-bottom-color: #3a3a3a;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
